module.exports = __webpack_public_path__ + "img/TPV-L1-5-Pagina2 A.bd5d5c38.png";